var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#DFF1E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9375 10.875V18.375H37.125V34.3125C37.125 35.8658 35.8658 37.125 34.3125 37.125H13.6875C12.1342 37.125 10.875 35.8652 10.875 34.3125V18.375H23.0625V10.875H24.9375ZM23.5371 31.0371L29.1621 25.4121C29.7598 24.9141 29.7627 24.0261 29.2131 23.4768C28.6635 22.9274 27.7737 22.9274 27.2244 23.4768L22.5938 28.1074L20.7756 26.2869C20.226 25.7375 19.3362 25.7372 18.7869 26.2869C18.2376 26.8365 18.2376 27.7262 18.7869 28.2755L21.5994 31.088C21.8742 31.3627 22.2363 31.5 22.5938 31.5C22.9512 31.5 23.3145 31.3652 23.5371 31.0371Z",
    fill: "#008A45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0625 10.875V18.375H10.9482C10.9373 18.3604 10.9299 18.3501 10.9226 18.3398C10.9153 18.3296 10.908 18.3193 10.897 18.3047L14.2002 12.157C14.4568 11.3877 15.167 10.875 15.9803 10.875H23.0625ZM33.798 12.1582L37.1016 18.3047C37.0928 18.3193 37.0854 18.3296 37.0781 18.3398C37.0708 18.3501 37.0635 18.3604 37.0547 18.375H24.9375V10.875H32.0215C32.8359 10.875 33.5449 11.3877 33.798 12.1582Z",
    fill: "#008A45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryCompleted);
export default __webpack_public_path__ + "static/media/delivery-completed.58ba257914c3cfd5dd5d117b80f1726a.svg";
export { ForwardRef as ReactComponent };